import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseAIAgentTemplateAttachmentDownloadMutationOptions {
	onSuccess?: (data: Api.IFileAttachment) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface AIAgentTemplateAttachmentDownloadMutationParams {
	templateId: string;
	attachmentId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function useAIAgentTemplateAttachmentDownloadMutation({
	onSuccess,
	onError,
}: UseAIAgentTemplateAttachmentDownloadMutationOptions = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({
			templateId,
			attachmentId,
			impersonationContext,
		}: AIAgentTemplateAttachmentDownloadMutationParams) => {
			return userSession.webServiceHelper.callAsync<Api.IFileAttachment>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `aiagenttemplate/${templateId}/attachments/${attachmentId}`,
				}),
				'GET'
			);
		},
		onSuccess,
		onError,
	});
}
